export default __webpack_public_path__ + "static/media/brands-goso.274c68d1.png";